import { apiPost } from "./api";
import { MarkReadResponse } from "../types/notification";

/**
 * Mark a single notification as read
 */
export const markNotificationAsRead = (notificationId: number) => {
  return apiPost<MarkReadResponse>(
    `admin-notification/${notificationId}/read`
  );
};

/**
 * Mark all unread notifications as read
 */
export const markAllNotificationsAsRead = () => {
  return apiPost<MarkReadResponse>("admin-notification/read-all");
};
